import React from 'react';
import classNames from 'classnames';
import { useAuthentication } from '@johnlewispartnership/wtr-website-authentication/dist/context';
import { TextLink } from '@johnlewispartnership/wtr-ingredients/ingredients/TextLink/index.js';
import { handleLoginWithRedirect } from 'utils/login';
import { urls } from 'constants/urls';
import { useMinSpend } from 'hooks/use-min-spend';
import { useTrolley } from 'contexts/Trolley';
import { ShoppingSummary } from './ShoppingSummary';
import styles from './ShoppingSummaryContainer.module.scss';
import { MobileShoppingSummary } from './MobileShoppingSummary';

const ShoppingSummaryContainer = ({
  mobileOnly,
  scrolled,
}: {
  mobileOnly?: boolean;
  scrolled?: boolean;
}) => {
  const { state: authState } = useAuthentication();
  const { showMinSpend } = useMinSpend();
  const { state: trolleyState } = useTrolley();

  // TODO - Move shouldRenderLoggedInVersion to a shared location to avoid repetition
  const shouldRenderLoggedInVersion =
    (authState.hasTokenSession && !authState.initialised) ||
    (authState.initialised && authState.isLoggedIn);

  const SignInOrTrolley = shouldRenderLoggedInVersion ? (
    <MobileShoppingSummary
      loadingStatus={trolleyState.loading}
      totalEstimatedCost={trolleyState.totalEstimatedCost}
      totalNumberOfItems={trolleyState.totalNumberOfItems}
      hasTrolleyError={!!trolleyState.error}
      testIdSuffix="mobile"
      scrolled={scrolled}
    />
  ) : (
    <TextLink
      data-testid="mobileHeaderSigninLink"
      href={urls.login}
      onClick={handleLoginWithRedirect}
      underline="never"
    >
      Sign in
    </TextLink>
  );

  return (
    <>
      {!mobileOnly && (
        <div className={styles.trolley} data-testid="shopping-summary-container-desktop">
          <ShoppingSummary />
        </div>
      )}
      <div
        className={classNames(styles.signInOrTrolley, {
          [styles.hasMinSpend]: showMinSpend,
        })}
        data-testid="shopping-summary-container-mobile"
      >
        {SignInOrTrolley}
      </div>
    </>
  );
};

export default ShoppingSummaryContainer;
